import DefaultMessageHandler, { type MessageHandler } from "./MessageHandler";
import { xsrfTokenHeaderName, xsrfTokenValue } from "./xsrfSynchronizerToken";

export let API_BASE = "";

let maxFileSizeString = "25 MByte";

/** imports sind imme readonly, deswegen brauchen wir einen separaten Setter */
export function setAPI_BASE(val) {
  API_BASE = val;
}

export function setMaxFileSizeString(val) {
  maxFileSizeString = val;
}

let defaultMessageHandler: MessageHandler = DefaultMessageHandler;

export function setMessageHandler( msgHandler: MessageHandler) {
  defaultMessageHandler = msgHandler;
}

export default async function apifetch(url: string, options: RequestInit | null = null, silent = false): Promise<Response> {
  let base = "";
  let fetchOpts = options;

  //absolute urls nicht mit API_BASE prefixen
  let regex = /(^.+:\/\/)|(^\/)/;
  if (!regex.test(url)) {
    base = API_BASE
  }


  if (xsrfTokenValue) {
    if (options && options.method) {
      if (["POST", "PUT", "PATCH", "DELETE"].includes(options.method.toUpperCase())) {
        if (!options.headers) {
          options.headers = {};
        }
        options.headers[xsrfTokenHeaderName] = xsrfTokenValue;
      }
    }
    // keine Opts, dann auch kein POST etc.
  }

  let resp = await fetch( base + url, fetchOpts);
    /* fetch wirft nur eine Expcetion, wenn eine Netzwerkfehler aufgetreten ist ...
      In der Regel ist es nützlicher, wenn bei einem nicht Okay-ischen  Response Code eine Exception geworfen wird.
    */
  if (!resp.ok && !resp.redirected) {
    let reloadPage = false;
    let err = "Es ist ein Fehler aufgetreten."
    if (resp.status === 403) {
      err = "<b>403</b>: Zugriff verweigert."
    }
    else if (resp.status === 413) {
      err = `<b>413</b>: maximale Dateigröße von ${maxFileSizeString} überschritten.`
    }
    else {
      try {
        try {
          let json = await resp.json();
          err = json.text;
          err = `<b>${json.statusText}</b>: ${json.text}`;
          reloadPage = json.promptPageReload;
        } catch (e) {
          err = await resp.text();
          console.error(e);
        }
      }
      catch (e) { }
    }
    if(!silent)
      defaultMessageHandler.error(err, reloadPage);
    throw new Error(err);
  }
  return resp;
}

export async function silentapifetch(url: string, options?: RequestInit) : Promise<Response> {
  return apifetch(url, options, true);
}